import _ from "lodash";
import * as React from "react";
import { faultComparator, createElementKey } from "../../utils/utils";
import FaultListItem from "../FaultListItem/FaultListItem";
import FaultListGroupItem from "../FaultListGroupItem/FaultListGroupItem";
import ElectrificationListItem from "../ElectrificationListItem/ElectrificationListItem";

type FaultListProps = {
  faults: Api.AnyFault[];
  faultPriorities: Api.FaultPriority[];
  faultDomains: Api.Domains;
  electrifications: Api.Electrification[];
  onItemClick: (resultType: number, code: any, domainId: any, inElectrification?: number) => void;
  selectedFault: Api.AnyFault | null;
  searchTerms: SearchTerms;
};

const FaultList: React.FC<FaultListProps> = ({
  faults,
  faultPriorities,
  faultDomains,
  electrifications,
  onItemClick,
  selectedFault,
  searchTerms
}: FaultListProps) => {
  const domainsAsArray = _.values(faultDomains);
  const faultCategoryIds = faults
    .filter(fault => fault.resultType === 1)
    .map(filtered => filtered.id);

  const faultSearchResultsElementsByElecrification = electrifications
    .filter(
      ele =>
        ele.enumValue.toString() == searchTerms.electrification ||
        searchTerms.electrification == "-1"
    )
    .map((ele, ix) => {
      const faultsInElectrification = faults
        .filter(fault => {
          return (
            fault.domain.electrificationEnumNames.includes(ele.enumName) &&
            (fault.domain.id.toString() == searchTerms.domainFilterInRequest ||
              searchTerms.domainFilterInRequest == "-1")
          );
        })
        .map(fault => ({ ...fault, inElectrification: ele.enumValue }));

      const faultSearchResultsElements = faultsInElectrification
        .sort(faultComparator(domainsAsArray))
        .map((fault: Api.AnyFault) => {
          // get priority data from id  for fault
          const faultPriority: any = faultPriorities.filter(
            (priority: any) => priority.id === fault.priority?.id
          )[0];
          // get domain data from id for fault
          const faultDomain: any = domainsAsArray.filter(
            (domain: any) => domain.id === fault.domain?.id
          )[0];

          if (fault.resultType == 1) {
            // drive fault category item
            const childItems = faults
              .filter(
                // currently only DriveFault has a category
                (item: Api.AnyFault) =>
                  (item as Api.DriveFault)?.faultCategory?.id === fault.id &&
                  item.domain.id == fault.domain.id
              )
              .map(fault => ({
                ...fault,
                inElectrification: ele.enumValue,
                inCategoryDomain: fault.domain.id
              }));
            return (
              <FaultListGroupItem
                groupItem={{
                  ...fault,
                  inElectrification: ele.enumValue,
                  inCategoryDomain: fault.domain.id
                }}
                key={createElementKey(ele.enumValue, fault.id, fault.domain.id)}
                childItems={childItems}
                faultPriorities={faultPriorities}
                faultDomains={faultDomains}
                onItemClick={onItemClick}
                selectedFault={selectedFault}
                domain={faultDomain}
                eleEnumValue={ele.enumValue}
                openByUrlParam={searchTerms.inCategoryDomain == fault.domain.id}
              />
            );
          } else if (
            !faultCategoryIds ||
            !faultCategoryIds.includes((fault as Api.DriveFault)?.faultCategory?.id)
          )
            return (
              <FaultListItem
                selected={
                  selectedFault?.code === fault.code &&
                  selectedFault?.domain.id === fault.domain.id &&
                  selectedFault?.inElectrification == fault.inElectrification
                }
                key={createElementKey(ele.enumValue, undefined, fault.domain.id, fault.id)}
                fault={fault}
                priority={faultPriority}
                domain={faultDomain}
                onItemClick={onItemClick}
              />
            );
        });
      return (
        <div key={ix}>
          {faultSearchResultsElements.length > 0 && (
            <ElectrificationListItem enumName={ele.enumName} />
          )}
          {faultSearchResultsElements}
        </div>
      );
    });
  return <div>{faultSearchResultsElementsByElecrification}</div>;
};

export default FaultList;
